import { Link } from 'react-router-dom';
import { useTranslations } from '@/i18n/use-translations';
import { PageStateLandmark } from '@/components/layout/main-landmark';

export function NotFoundPage() {
  const t = useTranslations('pages.not-found');

  return (
    <PageStateLandmark className="mx-auto flex max-w-3xl flex-col items-center justify-center gap-4 p-8">
      <h2 className="text-2xl font-semibold">{t('title')}</h2>
      <p className="text-text-secondary">{t('body')}</p>
      {/*
       * `text-primary` named no palette this preset declares, so the link
       * inherited body text and did not read as a link until hovered. Note
       * `interactive` and `--text-primary` are both #111827: the colour alone
       * cannot restore the affordance, so the underline is permanent rather
       * than hover-only — the house pattern for an inline link (IMM-565).
       */}
      <Link to="/" className="text-interactive underline underline-offset-4">
        {t('back-to-home')}
      </Link>
    </PageStateLandmark>
  );
}
